import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import userProfile from '../../../../assets/images/userProfile.svg';
import EquipmentsParamEdit from './equipmentsParamEdit';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useHook as EquipmentsDashboard } from './useHook';
import EquipmentsNameEdit from './equipmentsNameEdit';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
import EquipmentsAlertsEditPage from './equipmentsAlertsEditPage';
interface Props {
  pagePermissionIDs: unknown;
}

const EditEquipment: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canGetEquipment =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::get');

  const canCategorielistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');

  const canRolelistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::list');

  const canControllerlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('controllers::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['equipments::get'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
        <li>{ErrorMessage['roles::list'] || ''}</li>
        <li>{ErrorMessage['controllers::list'] || ''}</li>
      </ul>
    </section>
  );
  const { id } = useParams();
  const { equipmentDetails } = useSelector((state: any) => state.equipments);
  const { fetchGetEquipmentDetails } = EquipmentsDashboard();
  const [openEdit, setOpenEdit] = useState(false);
  const getEquipmentDetails = async () => {
    await fetchGetEquipmentDetails({ equipmentID: id });
  };
  useEffect(() => {
    if (
      canGetEquipment &&
      canCategorielistPermission &&
      canRolelistPermission &&
      canControllerlistPermission
    ) {
      getEquipmentDetails();
    }
  }, [
    canGetEquipment,
    canCategorielistPermission,
    canRolelistPermission,
    canControllerlistPermission,
  ]);
  const handleCloseEdit = () => {
    setOpenEdit(false);
    getEquipmentDetails();
  };

  return (
    <>
      {!canGetEquipment ||
      !canCategorielistPermission ||
      !canRolelistPermission ||
      !canControllerlistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {openEdit ? (
            <EquipmentsNameEdit
              editData={equipmentDetails}
              handleCloseEdit={handleCloseEdit}
              pagePermissionIDs={pagePermissionIDs}
            />
          ) : (
            <>
              <div className="edit_controller-header">
                <div className="edit_controller-header_content">
                  <img
                    src={equipmentDetails?.image || userProfile}
                    width="80"
                    height="80"
                    alt="controller"
                  />
                  <div>
                    <h4>{equipmentDetails?.equipmentName}</h4>
                    <p>{equipmentDetails?.model}</p>
                  </div>
                </div>

                <div className="edit_controller-header_icons">
                  <Button onClick={() => setOpenEdit(true)}>
                    <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                  </Button>
                </div>
              </div>
              <EquipmentsParamEdit editData={equipmentDetails} />
              <EquipmentsAlertsEditPage editData = {equipmentDetails}/>
            </>
          )}
        </>
      )}
    </>
  );
};

export default EditEquipment;
